<div class="relative overflow-hidden">
  
  <!-- Przycisk zamknięcia - X w prawym górnym rogu -->
  <button 
    mat-icon-button 
    (click)="close()"
    class="!absolute top-2 right-2 z-20 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
    <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
  </button>

  <!-- Background decoration -->
  <div class="absolute inset-0 -z-10 pointer-events-none overflow-hidden">
    <div class="absolute -top-32 -right-32 w-96 h-96 bg-gradient-to-br from-amber-500/20 to-orange-500/20 rounded-full blur-3xl"></div>
    <div class="absolute -bottom-32 -left-32 w-80 h-80 bg-gradient-to-tr from-primary-500/20 to-purple-500/20 rounded-full blur-3xl"></div>
  </div>

  <div class="relative z-10 p-6 sm:p-8">
    
    <!-- Header z ikoną -->
    <div class="flex flex-col items-center text-center mb-6">
      <div class="relative">
        <div class="absolute inset-0 bg-amber-400/30 rounded-full blur-xl animate-pulse"></div>
        <div class="relative w-20 h-20 rounded-2xl bg-gradient-to-br from-amber-400 via-amber-500 to-orange-500 flex items-center justify-center shadow-lg shadow-amber-500/30">
          <mat-icon [svgIcon]="'tabler_outline:file-alert'" class="!w-10 !h-10 text-white"></mat-icon>
        </div>
      </div>
      
      <h2 class="mt-6 text-2xl sm:text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight">
        Osiągnąłeś limit dokumentów
      </h2>
      
      <p class="mt-3 text-gray-500 dark:text-gray-400 text-base max-w-sm">
        Wykorzystałeś limit dokumentów dostępnych w Twoim planie w tym miesiącu.
      </p>
    </div>

    <!-- CTA Card - zachęta do zakupu -->
    <div class="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 dark:from-gray-800 dark:via-gray-900 dark:to-black p-6 mb-6">
      
      <!-- Dekoracja -->
      <div class="absolute top-0 right-0 w-48 h-48 bg-gradient-to-br from-primary-500/20 to-purple-500/20 rounded-full blur-2xl"></div>
      <div class="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-blue-500/20 to-cyan-500/20 rounded-full blur-2xl"></div>
      
      <div class="relative z-10">
        <div class="flex items-center gap-2 mb-3">
          <mat-icon [svgIcon]="'tabler_outline:sparkles'" class="text-amber-400 !w-5 !h-5"></mat-icon>
          <span class="text-amber-400 text-sm font-semibold uppercase tracking-wider">Odblokuj pełen potencjał</span>
        </div>
        
        <h3 class="text-xl font-bold text-white mb-4">
          Przejdź na wyższy plan i zapomnij o limitach!
        </h3>
        
        <!-- Korzyść -->
        <div class="flex items-center gap-3">
          <div class="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4 text-green-400"></mat-icon>
          </div>
          <span class="text-gray-300 text-sm">Więcej dokumentów lub bez limitu</span>
        </div>
      </div>
    </div>

    <!-- Przycisk - główny CTA -->
    <button 
      (click)="goToSubscription()"
      class="group relative w-full h-14 inline-flex items-center justify-center text-base font-bold text-white transition-all duration-300 rounded-xl overflow-hidden
             bg-gradient-to-r from-primary-500 via-primary-600 to-purple-600
             hover:from-primary-400 hover:via-primary-500 hover:to-purple-500
             shadow-lg shadow-primary-500/25 hover:shadow-xl hover:shadow-primary-500/40
             hover:scale-[1.02] active:scale-100">
      <span class="relative z-10 flex items-center gap-3">
        <mat-icon [svgIcon]="'tabler_outline:crown'" class="!w-6 !h-6 text-white"></mat-icon>
        <span>Zobacz dostępne plany</span>
        <mat-icon [svgIcon]="'tabler_outline:arrow-right'" class="!w-5 !h-5 text-white transition-transform group-hover:translate-x-1"></mat-icon>
      </span>
      <div class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
    </button>

    <!-- Trust signal -->
    <div class="mt-4 flex items-center justify-center gap-4 text-xs text-gray-400">
      <div class="flex items-center gap-1.5">
        <mat-icon [svgIcon]="'tabler_outline:shield-check'" class="!w-4 !h-4 text-green-500"></mat-icon>
        <span>Bezpieczne płatności</span>
      </div>
      <div class="flex items-center gap-1.5">
        <mat-icon [svgIcon]="'tabler_outline:calendar-off'" class="!w-4 !h-4 text-blue-500"></mat-icon>
        <span>Bez zobowiązań</span>
      </div>
    </div>
  </div>
</div>
